<template>
  <LoadingScreen v-cloak="true" />

  <template v-if="isSamsungBrowser">
    <SamsungError />
  </template>

  <div class="pointer-events-none fixed inset-0 z-50">
    <svg
      class="h-[150vh] w-full object-cover object-center"
      xmlns="http://www.w3.org/2000/svg"
    >
      <filter id="noise">
        <feTurbulence
          type="fractalNoise"
          baseFrequency="0.65"
          numOctaves="1"
          stitchTiles="stitch"
        />
        <feBlend mode="screen" />
      </filter>
      <rect ref="noise" class="size-full" filter="url(#noise)" opacity="0.15" />

      <filter id="noise">
        <feTurbulence
          type="fractalNoise"
          base-frequency="0.8"
          numOctaves="1"
          stitchTiles="stitch"
        />
        <feBlend mode="screen" />
      </filter>
      <rect
        ref="noise"
        class="size-full"
        filter="url(#noise)"
        opacity="-0.88"
      />
    </svg>
  </div>

  <Cursor />
  <Navbar @isLocked="LockeScroll" />

  <main class="relative min-h-full">
    <Hero />
    <div
      class="text-flax-smoke-200 relative rounded-t-3xl bg-[#121226] py-[5%]"
    >
      <Services />
      <Marquee />
      <Works />
    </div>

    <aboutMe />
    <People />
    <PlayerReviews />
    <Contact />
  </main>

  <Footer />
</template>

<script setup lang="ts">
  import Hero from '@/components/sections/Hero.vue';
  import People from '@/components/sections/People.vue';
  import PlayerReviews from '@/components/sections/PlayerReviews.vue';
  import Services from '@/components/sections/Services.vue';
  import Works from '@/components/sections/Works.vue';
  import aboutMe from '@/components/sections/aboutMe.vue';
  import Contact from '@/components/sections/Contact.vue';
  import { onMounted, type Ref, ref, watch } from 'vue';
  import LoadingScreen from '@/components/design/LoadingScreen.vue';
  import Marquee from '@/components/design/Marquee.vue';
  import SamsungError from '@/components/design/SamsungError.vue';
  import Footer from '@/components/design/Footer.vue';
  import Cursor from '@/components/design/Cursor.vue';
  import { useWindowSize } from '@vueuse/core';

  import Navbar from './components/common/Nav.vue';
  import { lenis, raf } from './main';
  const { width, height } = useWindowSize();
  const noise: Ref<HTMLElement | null> = ref(null);

  const isSamsungBrowser = /samsung/i.test(navigator.userAgent);

  const LockeScroll = (isLocked: boolean) => {
    if (isLocked) {
      lenis.stop();
    } else {
      lenis.start();
    }
  };

  watch([width, height], () => {
    if (noise.value) {
      noise.value.style.height = `${height.value * 2}px`;
      noise.value.style.width = `${width.value}px`;
    }
  });

  onMounted(() => {
    document.body.classList.add('stop-scrolling');
    // TODO:
    // window.scrollTo(0, 0);

    setTimeout(() => {
      requestAnimationFrame(raf);
    }, 2000);
  });
</script>

<style>
  .stop-scrolling #app {
    max-height: 100svh !important;
    overflow: hidden !important;
  }
</style>
